import { COLORS } from '@btime/constants'
import { appendIf } from '@btime/helpers'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'

import {
  useOpenEditAssetModal,
  useOpenAssetModal,
  useOpenEditAssetsModal,
  useOpenGenerateActivatedQRCodesModal
} from '../../../utils/routes/modals/modalsActions'
import { useRemoveAssets } from './_requests/removeAssets'

export const useAssetActions = (item, ids, opts = {}) => {
  const hide = opts.hide || []
  const canEdit = useSessionPermission('editAsset')
  const canDelete = useSessionPermission('deleteAsset')
  const { t } = useTranslation('common')

  const openDetailsModal = useOpenAssetModal()
  const openEditModal = useOpenEditAssetModal()
  const openBulkModal = useOpenEditAssetsModal()
  const openGenerateActivatedQRCodesModal = useOpenGenerateActivatedQRCodesModal()

  const [deleteItems, { loading }] = useRemoveAssets()

  const singleOptions = [
    ...appendIf(!hide.includes('seeDetails'), {
      value: t('seeDetails'),
      icon: 'BsSearch',
      onClick: () => openDetailsModal(item)
    }),

    {
      value: t('assets.generateQrCode'),
      icon: 'IoQrCodeOutline',
      onClick: () => openGenerateActivatedQRCodesModal({ ids: [item.id], type: 'assets' })
    },

    ...appendIf(canEdit, {
      value: t('edit'),
      icon: 'BsPencil',
      onClick: () => openEditModal(item.id)
    }),

    ...appendIf(canDelete, {
      value: t('remove'),
      color: COLORS.red,
      icon: 'BsTrash',
      onClick: () => deleteItems([item.id])
    })
  ]

  const multiOptions = [
    {
      value: t('assets.generateQrCodes'),
      icon: 'IoQrCodeOutline',
      onClick: () => openGenerateActivatedQRCodesModal({ ids, type: 'assets' })
    },

    ...appendIf(canEdit && ids?.length <= 20, {
      value: t('edit'),
      icon: 'BsPencil',
      onClick: () => openBulkModal(ids)
    }),

    ...appendIf(canDelete, {
      value: t('remove'),
      color: COLORS.red,
      icon: 'BsTrash',
      onClick: () => deleteItems(ids)
    })
  ]

  return [!ids || ids.length === 1 ? singleOptions : multiOptions, loading]
}
